import * as Yup from 'yup';
import { LanguagesType } from 'App/i18n';

export const buildValidationSchema = (
  languages: LanguagesType[],
): Yup.AnyObjectSchema =>
  Yup.object()
    .shape({
      name: Yup.object().shape({
        ...languages.reduce(
          (acc, current) => ({
            ...acc,
            [current]: Yup.string()
              .trim()
              .required('businessDataPage.update.errorName'),
          }),
          {},
        ),
      }),
      // Phone fields with conditional validation (avoiding circular dependencies)
      ownerPhoneCountry: Yup.string().trim(),
      ownerPhoneArea: Yup.string().trim(),
      phoneNumber: Yup.string().trim(),
      orderTaxesEnabled: Yup.boolean(),
      orderTaxesPercent: Yup.string()
        .trim()
        .test(
          'maxPercentage',
          'businessDataPage.generalInformationCard.errors.orderTaxesPercent.valueMax',
          (_, { parent: { orderTaxesEnabled, orderTaxesPercent } }) =>
            (orderTaxesEnabled &&
              Number(orderTaxesPercent) >= 0 &&
              Number(orderTaxesPercent) <= 100) ||
            !orderTaxesEnabled,
        )
        .when('orderTaxesEnabled', {
          is: true,
          then: Yup.string().required(
            'businessDataPage.generalInformationCard.errors.orderTaxesPercent.required',
          ),
        }),
    })
    .test(
      'phoneFieldsValidation',
      'Phone fields validation',
      function (values) {
        const { ownerPhoneCountry, ownerPhoneArea, phoneNumber } = values || {};

        const hasOwnerPhoneCountry = ownerPhoneCountry?.trim();
        const hasOwnerPhoneArea = ownerPhoneArea?.trim();
        const hasPhoneNumber = phoneNumber?.trim();
        const hasAnyPhoneField =
          hasOwnerPhoneCountry || hasOwnerPhoneArea || hasPhoneNumber;

        if (!hasAnyPhoneField) return true;

        const phoneFieldErrors = [
          {
            field: 'ownerPhoneCountry',
            hasValue: hasOwnerPhoneCountry,
            message:
              'businessDataPage.generalInformationCard.errors.ownerPhoneCountry.required',
          },
          {
            field: 'ownerPhoneArea',
            hasValue: hasOwnerPhoneArea,
            message:
              'businessDataPage.generalInformationCard.errors.ownerPhoneArea.required',
          },
          {
            field: 'phoneNumber',
            hasValue: hasPhoneNumber,
            message:
              'businessDataPage.generalInformationCard.errors.phoneNumber.required',
          },
        ];

        const errors = phoneFieldErrors
          .filter(({ hasValue }) => !hasValue)
          .map(({ field, message }) =>
            this.createError({ path: field, message }),
          );

        if (errors.length > 0) throw new Yup.ValidationError(errors);
        return true;
      },
    );
